<template>
  <div>
    <el-table
        :data="tableData"
        :cell-style="rowClassName"
        :header-cell-style="headerClassName"
        border
        style="width: 100% !important;"
    >
      <el-table-column prop="name" show-overflow-tooltip label="Name" width="120" style="background-color: #e8e8e8;">
        <template #default="{row}">
          <span>{{ row?.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="value" label="Value" width="360">
        <template #default="{ row }">
          <!-- 来源 -->
          <template
              v-if="row?.name === $t('common.customer.source') && Array.isArray(row.value) && row.value.length > 0">
            <el-tag v-for="it in row.value" :key="it.name" type="info" style="margin: 2px;">
              {{ getTagDisplayValue(it.name) }}
            </el-tag>
          </template>
          <!-- 兴趣产品 -->
          <template
              v-else-if="row?.name === $t('common.interest.product') && Array.isArray(row.value) && row.value.length > 0">
            <el-tag v-for="it in row.value" :key="it.name" type="info" style="margin: 2px;">
              {{ getTagDisplayValue(it.name) }}
            </el-tag>
          </template>
          <template v-else-if="row?.name === $t('common.name')">
            <div style="display: flex;align-items: center;justify-content: flex-start">
              <el-icon v-if="row?.isMain" style="margin-right: 5px;">
                <User/>
              </el-icon>
              <span style="width: 25vw;overflow: hidden;text-overflow: ellipsis;white-space: nowrap;">
                {{
                  row.value
                }}
              </span>
            </div>
          </template>
          <!-- 普通显示 + Tooltip -->
          <template v-else>
            <el-tooltip
                effect="dark"
                :content="getDisplayValue(row?.value)"
                placement="top"
                :show-after="1200"
                :popper-style="{ maxWidth: '300px', maxHeight: '200px', overflowY: 'auto', whiteSpace: 'normal', wordBreak: 'break-word' }"
            >
              <div class="popover-content"
                   style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                {{ getDisplayValue(row?.value) }}
              </div>
            </el-tooltip>
          </template>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script setup>
import {defineProps} from "vue";
import {ElTable} from "element-plus";
import {i18n} from "@/lang";
import {User} from "@element-plus/icons-vue";
import {formatText, getTextLength} from "@/utils/util";

const props = defineProps({
  tableData: {
    type: Array,
    default: () => [],
  },

  tableKeys: {
    type: Array,
    default: () => ["value", "name"],
  },
});

const TAG_TEXT_LIMIT = 16;


const rowClassName = ({row, column, rowIndex, columnIndex}) => {
  // console.log(row, columnIndex)
  if (columnIndex === 0 || columnIndex === 1) {
    return {textAlign: 'left'}
  } else {
    return {textAlign: 'center'}
  }
}

const headerClassName = ({row, column, rowIndex, columnIndex}) => {
  if (columnIndex === 0 || columnIndex === 1) {
    return {'text-align': 'left', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  } else {
    return {'text-align': 'center', background: '#f9f9f9', color: 'black', padding: '8px 0px'}
  }
}

function isOverflowing(text) {
  // 可根据内容字符长度粗略判断是否溢出
  return text && text.length > 30 // 你也可以用具体像素判断
}

function getDisplayValue(val) {
  // 如果是空数组，返回空字符串；否则返回原值
  if (Array.isArray(val) && val.length === 0) return ''
  return val ?? '' // 防止 null/undefined
}

function getTagDisplayValue(val) {
  const tagValue = getDisplayValue(val)
  if (getTextLength(tagValue) > TAG_TEXT_LIMIT) {
    return formatText(tagValue, TAG_TEXT_LIMIT, true)
  }
  return tagValue
}
</script>

<style lang="less" scoped>
:deep(.el-table__header-wrapper) {
  display: none;
}

:deep(.el-empty__image img) {
  width: 54% !important;
}

:deep(.el-empty__description) {
  margin-top: -20px;
}

</style>
